var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner-page" },
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner edi-address-format-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.AntiTerroristFormattedAddress"),
            width: "840px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c(
              "div",
              { staticStyle: { height: "490px" } },
              [
                _c(
                  "el-scrollbar",
                  {
                    staticStyle: { height: "500px", width: "820px" },
                    attrs: { native: true }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { width: "640px" },
                        attrs: {
                          inline: true,
                          "label-width": "40px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "el-form-item-wrapper",
                            staticStyle: { "padding-left": "116px" }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      checked:
                                        _vm.addressForm.consolidationClosed ===
                                        1
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.LCLLastBillOfLading")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("div", { staticClass: "el-form-item-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "app-main-inner-row form-item-border-group"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "form-item-group-label" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Message.Shipper")))
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item-long",
                                      attrs: { label: _vm.$t("Tool.Name") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.shipperLine1,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperLine1",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.shipperLine1"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.shipperLine2,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperLine2",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.shipperLine2"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item-long",
                                      attrs: { label: _vm.$t("SeaExport.Addr") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.shipperLine3,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperLine3",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.shipperLine3"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.shipperLine4,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperLine4",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.shipperLine4"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.shipperLine5,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperLine5",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.shipperLine5"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.Country")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.shipperCountry,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperCountry",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.shipperCountry"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.Province")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.shipperProvince,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperProvince",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.shipperProvince"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.City") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.shipperCity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperCity",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.shipperCity"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.ZIP") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.shipperPostalcode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperPostalcode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.shipperPostalcode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.Tel") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.shipperTel,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperTel",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.shipperTel"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.Fax") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.shipperFax,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "shipperFax",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.shipperFax"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "el-form-item-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "app-main-inner-row form-item-border-group"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "form-item-group-label" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Message.Consignee")))
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item-long",
                                      attrs: { label: _vm.$t("Tool.Name") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.consigneeLine1,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeLine1",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.consigneeLine1"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.consigneeLine2,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeLine2",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.consigneeLine2"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item-long",
                                      attrs: { label: _vm.$t("SeaExport.Addr") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.consigneeLine3,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeLine3",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.consigneeLine3"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.consigneeLine4,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeLine4",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.consigneeLine4"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.consigneeLine5,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeLine5",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.consigneeLine5"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.Country")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.consigneeCountry,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeCountry",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.consigneeCountry"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.Province")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.consigneeProvince,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeProvince",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.consigneeProvince"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.City") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.consigneeCity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeCity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.consigneeCity"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.ZIP") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.consigneePostalcode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneePostalcode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.consigneePostalcode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.Tel") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.consigneeTel,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeTel",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.consigneeTel"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.Fax") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.consigneeFax,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "consigneeFax",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.consigneeFax"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "el-form-item-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "app-main-inner-row form-item-border-group"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "form-item-group-label" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Message.Notify")))
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item-long",
                                      attrs: { label: _vm.$t("Tool.Name") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyLine1,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyLine1",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.notifyLine1"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyLine2,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyLine2",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.notifyLine2"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item-long",
                                      attrs: { label: _vm.$t("SeaExport.Addr") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyLine3,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyLine3",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.notifyLine3"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyLine4,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyLine4",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.notifyLine4"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyLine5,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyLine5",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.notifyLine5"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.Country")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyCountry,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyCountry",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.notifyCountry"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.Province")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyProvince,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyProvince",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.notifyProvince"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.City") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyCity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyCity",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.notifyCity"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.ZIP") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.notifyPostalcode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyPostalcode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.notifyPostalcode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.Tel") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyTel,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyTel",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.notifyTel"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.Fax") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.notifyFax,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "notifyFax",
                                              $$v
                                            )
                                          },
                                          expression: "addressForm.notifyFax"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "el-form-item-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "app-main-inner-row form-item-border-group"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "form-item-group-label" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Message.SecondNotify"))
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item-long",
                                      attrs: { label: _vm.$t("Tool.Name") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.alsonotifyLine1,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyLine1",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyLine1"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.alsonotifyLine2,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyLine2",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyLine2"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item-long",
                                      attrs: { label: _vm.$t("SeaExport.Addr") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.alsonotifyLine3,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyLine3",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyLine3"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.alsonotifyLine4,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyLine4",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyLine4"
                                        }
                                      }),
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.alsonotifyLine5,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyLine5",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyLine5"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.Country")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.alsonotifyCountry,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyCountry",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyCountry"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.Province")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm.alsonotifyProvince,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyProvince",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyProvince"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.City") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.alsonotifyCity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyCity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyCity"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.ZIP") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.addressForm
                                              .alsonotifyPostalcode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyPostalcode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyPostalcode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.Tel") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.alsonotifyTel,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyTel",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyTel"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.Fax") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.addressForm.alsonotifyFax,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addressForm,
                                              "alsonotifyFax",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addressForm.alsonotifyFax"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "inline-block",
                  position: "absolute",
                  left: "0",
                  "padding-left": "10px"
                }
              },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.copyLatest } },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.CopyFromTheLastTime")))]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.billCopy } },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.CopyFromOtherBill")))]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.copyHbl } },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.CopyFromHbl")))]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { display: "inline-block" } },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.save } },
                  [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                ),
                _c("el-button", { on: { click: _vm.close } }, [
                  _vm._v(_vm._s(_vm.$t("common.btn.close")))
                ])
              ],
              1
            )
          ])
        ]
      ),
      _c("search-bill-no-dialog", {
        attrs: {
          visible: _vm.searchBillNoDialog.visible,
          params: _vm.searchBillNoDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
          },
          selected: _vm.selectAddressInfo
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }